import { Spin } from 'antd';
import OrderMethodItem from 'components/pages/dashboard/ParcelOrder/components/orderMethods/OrderMethodItem';
import OrderMethodServiceRow from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderMethods/components/OrderMethodServiceRow';
import OrderMethodServiceTypeItem from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderMethods/components/OrderMethodServiceTypeItem';
import SelectReceiverLocationModal from 'components/pages/dashboard/parcelOrderForBranch/components copy/orderMethods/components/SelectReceiverLocationModal';
import { omOrderServices, packageCreate } from 'global/Models/omOrderModel';
import { FC, useState } from 'react';
import { FiAlertTriangle } from 'react-icons/fi';
import { HiOutlineTruck } from 'react-icons/hi';

interface IOrderMethodServiceType {
  setOrderServices: React.Dispatch<React.SetStateAction<omOrderServices>>;
  orderServices: omOrderServices;
  priceLoading?: boolean;
  packages: packageCreate[];
}

const OrderMethodServiceType: FC<IOrderMethodServiceType> = ({ setOrderServices, orderServices, priceLoading, packages }) => {
  //states
  const [selectReceiverLocation, setselectReceiverLocation] = useState<{
    routeIndex: number;
    hasLatLong: boolean;
    hasPostalCode: boolean;
  }>();

  //states
  const handleChange = (routeIndex: number, serviceIndex: number, lat: number | undefined, long: number | undefined, postalCode: string | undefined) => {
    if (orderServices[routeIndex].serviceList[serviceIndex].serviceId == 11 && (!lat || !long || !postalCode)) {
      setselectReceiverLocation({
        routeIndex,
        hasLatLong: !!(lat && long),
        hasPostalCode: !!postalCode,
      });
      return;
    }

    if (orderServices.length === 0) return;
    if (orderServices[routeIndex].serviceList[serviceIndex].selected) return;

    const tempServices = orderServices.map((route, thisRouteIndex) => {
      if (thisRouteIndex !== routeIndex) return route;

      route.serviceList.map((_service, thisServiceIndex) => {
        if (thisRouteIndex === routeIndex && thisServiceIndex === serviceIndex) {
          route.serviceList[thisServiceIndex].selected = true;
        } else {
          route.serviceList[thisServiceIndex].selected = false;
        }
      });
      return route;
    });
    setOrderServices([...tempServices]);
  };

  const renderResultService = () => {
    if (!priceLoading && orderServices && orderServices.length > 0) {
      return (
        <div className='grid'>
          <div className='flex flex-col gap-4 p-2 overflow-x-auto'>
            {orderServices?.map((route, routeIndex) => {
              const { postalCode, latitude, longitude } = packages[routeIndex].receiverAddress?.address || {};

              return (
                <OrderMethodServiceRow route={route} key={routeIndex}>
                  {route.serviceList
                    .sort((a, b) => {
                      if (a.serviceId === 11 && b.serviceId !== 11) return -1;
                      if (a.serviceId !== 11 && b.serviceId === 11) return 1;
                      return 0;
                    })
                    .map((service, serviceIndex) => (
                      <OrderMethodServiceTypeItem
                        key={service.serviceId + route.sourceCity + route.destCity}
                        handleChange={() => handleChange(routeIndex, serviceIndex, latitude, longitude, postalCode)}
                        isSelected={service.selected}
                        serviceName={service.serviceKind}
                        serviceId={service.serviceId}
                        deliveryDay={service.deliveryDay}
                      />
                    ))}
                </OrderMethodServiceRow>
              );
            })}
          </div>
        </div>
      );
    }

    return <></>;
  };

  //loading of fetch GetServicesOfOrder
  if (priceLoading) {
    return (
      <div className='text-xs text-t-secondary-text-color'>
        <Spin spinning size='small' />
        درحال بارگزاری سرویس ارسال...
      </div>
    );
  }
  //For whatever reason, an error occurred.
  if (!priceLoading && orderServices && orderServices.length === 0) {
    return (
      <OrderMethodItem icon={<FiAlertTriangle className='text-2xl stroke-t-error-color' />} title={<span className='text-t-error-color'>سرویس ارسال</span>}>
        <p className='text-[14px] font-medium'>در شهر فرستنده یا گیرنده، نمایندگی فعال تیپاکس وجود ندارد.</p>
      </OrderMethodItem>
    );
  }

  return (
    <>
      <OrderMethodItem icon={<HiOutlineTruck className='text-2xl' />} title='سرویس ارسال'>
        {renderResultService()}
      </OrderMethodItem>

      <SelectReceiverLocationModal
        visible={selectReceiverLocation !== undefined}
        selectReceiverLocation={selectReceiverLocation}
        close={() => setselectReceiverLocation(undefined)}
        packages={packages}
        setOrderServices={setOrderServices}
      />
    </>
  );
};

export default OrderMethodServiceType;
